export default __webpack_public_path__ + "static/media/WaitingForHololens.d521ee3a.png";